// @flow

const setupHeaders = (token: string, apiKey: string) => ({
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
});

export const acceptInvite = (
    token: string,
    homeName: string,
    userId: string,
    homeServiceUrl: string,
    apiKey: string,
    authToken: string
): Promise<Response> => {
    const endpoint = `${homeServiceUrl}home/owner/${userId}/invitation/accept`;
    const headers = setupHeaders(authToken, apiKey);
    return fetch(endpoint, { headers, method: 'POST', body: JSON.stringify({ token, homeName }) });
};

export const validateToken = (
    token: string,
    homeServiceUrl: string,
    apiKey: string,
    authToken: string
): Promise<Response> => {
    const endpoint = `${homeServiceUrl}home/invitation/${token}`;
    const headers = setupHeaders(authToken, apiKey);
    return fetch(endpoint, { headers });
};



// WEBPACK FOOTER //
// ./src/core/api/assisted-living/index.js